import React, { useContext, useState, useRef, useEffect } from "react";
import { flow, map, uniq, filter, includes } from "lodash/fp";

import StoreContext from "context/Store";

import { getCollections, getOptionGroups } from "utils/product";

import { CollectionMenu, DesignerMenu, OptionGroupMenu } from "./Menu";

import { Accordion } from "./Menu/Menu.styles";
import { extractCategoryTiers } from "../../adapters";
import { graphql, useStaticQuery } from "gatsby";

const FilterAccordion = ({ title, products, className, handle }) => {
  const { allShopifyProduct } = useStaticQuery(graphql`
    query {
      allShopifyProduct {
        edges {
          node {
            tags
          }
        }
      }
    }
  `);

  const {
    collection: { 
      filters, 
      toggleFilter, 
      sizeLocale,
      setSizeLocale 
    },
  } = useContext(StoreContext);

  const collectionScrollContentRef = useRef();

  const [openItem, setOpenItem] = useState();
  const [scrollHeight, setScrollHeight] = useState();

  const allCollections = getCollections(products);

  const vendors = flow(map("vendor"), uniq)(products);

  const designers = flow(filter((c) => includes(c.title)(vendors)))(
    allCollections
  );

  const optionGroups = getOptionGroups(products);

  useEffect(() => {
    const { current } = collectionScrollContentRef;

    if (current && openItem) {
      const max = 420;
      setScrollHeight(current.clientHeight > max ? max : current.clientHeight);
    }
  }, [openItem]);

  const onItemClick = (item) => {
    setOpenItem(item === openItem ? false : item);
  };
  
  const onSizeLocaleChange = (option) => {
    setSizeLocale(option);
  };

  const catTiers = extractCategoryTiers(allShopifyProduct?.edges);
  return (
    <Accordion className={className}>
      <CollectionMenu
        scrollHeight={scrollHeight}
        onItemClick={onItemClick}
        catTiers={catTiers}
        filters={filters}
        openItem={openItem}
        collectionScrollContentRef={collectionScrollContentRef}
        toggleFilter={toggleFilter}
        handle={handle}
      />
      <DesignerMenu
        scrollHeight={scrollHeight}
        onItemClick={onItemClick}
        designers={designers}
        filters={filters}
        openItem={openItem}
        collectionScrollContentRef={collectionScrollContentRef}
        toggleFilter={toggleFilter}
      />
      <OptionGroupMenu
        scrollHeight={scrollHeight}
        onItemClick={onItemClick}
        optionGroups={optionGroups}
        filters={filters}
        openItem={openItem}
        collectionScrollContentRef={collectionScrollContentRef}
        toggleFilter={toggleFilter}
        sizeLocale={sizeLocale}
        title={title}
        onSizeLocaleChange={onSizeLocaleChange}
      />
    </Accordion>
  );
};

export default FilterAccordion;
